export default "__VITE_ASSET__DvsHU1BV__"